////////////////////////////////
// Every project has this file,
// but it is seperate from the
// architecture

export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SECONDS = 600;
export const RESULTS_PER_PAGE = 10;
export const DEV_KEY = `516d8bbc-0f1b-44b2-a601-d9c196cbf990`;
export const MODAL_CLOSE_SECONDS = 0.5;
